import styled from "styled-components";
import { colors } from "constants/colors";
import { styleSizes } from "constants/styleSizes";

export const AddOnCardContainer = styled.div<{ selected?: boolean }>`
  min-width: 260px;
  -webkit-box-shadow: 0px 1px 3px 0px ${colors.accounMenuBorderShadowColor};
  -moz-box-shadow: 0px 1px 3px 0px ${colors.accounMenuBorderShadowColor};
  box-shadow: 0px 1px 3px 0px ${colors.accounMenuBorderShadowColor};
  border: 1px solid ${colors.accounMenuBorderColor};
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-content: stretch;
  flex: 1;
  color: ${colors.almostBlack};

  .optionCardTitle {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 5px;
    line-height: 20px;
    color: ${colors.almostBlack};
    margin-bottom: 18px;
  }

  .optionCardAttributes {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    flex-wrap: wrap;
    gap: 16px;
    margin-bottom: 8px;

    .roomAttribute {
      display: flex;
      //margin: 0 2% 0 0;
      align-items: center;
      align-items: flex-start;
      gap: 8px;
      /* letter-spacing: -0.5px; */
      .roomAttributeText {
        font-size: 16px;
        flex: 1;
      }
      svg {
        position: relative;
        width: 12px;
        height: 12px;
        margin-top: 3px;
      }
    }
  }
  .attributesText {
    color: ${colors.noBookingText};
    padding: 12px 0;
    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      display: none;
    }
  }

  .optionCardPrice {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border: 1px solid ${colors.signInBorderColor};
    padding: 16px;
    margin-top: 8px;
    white-space: nowrap;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 8px;

    .switch {
      width: 37px;
      min-width: 37px;
      height: 24px;
      border: 2px solid ${colors.profileBorder};
      background-color: ${colors.accounMenuBorderColor};
      border-radius: 14px;
      cursor: pointer;

      .switchSlider {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        background-color: ${colors.white};
        position: relative;
        top: calc(50% - 8px);
        left: 2px;
        transition: transform 0.3s ease;

        svg {
          position: relative;
          width: 9px;
          height: 9px;
          margin: 3px;
        }
      }

      .switchSlider.active {
        transform: translateX(13px);

        svg {
          top: 0;
          left: 0;
        }
      }
    }

    .switch.active {
      border: 2px solid ${colors.optionBackground};
      background-color: ${colors.optionBackground};
    }

    .counterPrice {
      display: flex;
      flex-direction: row;
      gap: 8px;
      align-items: center;
      margin-top: 1px;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        justify-content: space-between;
        width: 100%;
        flex-direction: row-reverse;
      }
    }

    .counterPriceRight {
      display: flex;
      flex-direction: row;
      gap: 8px;
      align-items: center;
      margin-top: 1px;
      @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
        flex-basis: 100%;
      }
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        flex-basis: 100%;
        flex: 1;
        width: 100%;
        justify-content: space-between;
      }
    }

    .price {
      font-size: 16px;
      font-weight: 600;
      color: ${colors.almostBlack};
    }

    .explanation {
      font-size: 16px;
      color: ${colors.menuGrey};
      white-space: normal;
      line-height: 26px;
      display: flex;
      flex-direction: row;
      gap: 3px;
      justify-content: flex-start;
      flex: 1;
      strong {
        font-weight: 600;
      }
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        line-height: 19px;
      }
    }
    .explanationRight {
      justify-content: flex-end !important;
      flex: 1;
      @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
        justify-content: flex-start !important;
        line-height: 24px;
      }
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        font-size: 14px;
      }
    }

    .counter {
      display: flex;
      align-items: center;
      gap: 1px;
    }

    .counterBtn {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: background 0.2s;
      user-select: none;
      transition: opacity 0.1s ease;
    }
    .counterBtn.disabled {
      opacity: 0.35;
      cursor: not-allowed;
      pointer-events: none;
    }
    .counterRt {
      margin-right: 8px;
    }

    .counterLft {
      margin-left: 8px;
    }

    .counterValue {
      font-size: 16px;
      font-weight: 600;
      text-align: center;
    }
    .counterText {
      font-size: 16px;
      font-weight: 600;
      margin-left: 4px;
      text-align: center;
    }
    .counterFor {
      margin-right: 16px;
      margin-left: 8px;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        display: none;
      }
    }
    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
      flex-direction: column;
    }
  }
`;
